import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import "./commentpopup.css";

const CommentPopup = ({ onClose, chapterId, lessonId, questionIndex, onNewComment }) => {
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");

  const apiUrl = process.env.REACT_APP_API_URL;

  // 🔹 1. ÎNCARCĂ COMENTARIILE DIN BACKEND
  useEffect(() => {
    fetch(`${apiUrl}/comments/${chapterId}/${lessonId}/${questionIndex}`, {
      credentials: "include", // trimite cookie JWT
    })
      .then((res) => {
        if (res.status === 401) return []; // dacă userul nu e logat
        return res.json();
      })
      .then((data) => setComments(data))
      .catch((err) => console.error("Eroare încărcare comentarii:", err));
  }, [chapterId, lessonId, questionIndex, apiUrl]);

  // 🔹 2. TRIMITE UN COMMENT LA BACKEND
  const handlePost = async () => {
    if (!newComment.trim()) return;

    const body = {
      chapter_id: chapterId,
      lesson_id: lessonId,
      question_index: questionIndex,
      comment_text: newComment,
    };

    const res = await fetch(`${apiUrl}/comments`, {
      method: "POST",
      credentials: "include", // trimite cookie JWT
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    if (res.status === 401) {
      alert("Trebuie să fii autentificat pentru a posta comentarii.");
      return;
    }

    const saved = await res.json();

    // comentariul nou apare instant
    setComments((prev) => [saved, ...prev]);

    // trimite notificare către FeedbackPopup pentru a actualiza iconița
    if (onNewComment) onNewComment();

    setNewComment("");
  };

  return (
    <div className="comment-popup-overlay">
      <div className="comment-popup">

        {/* Buton închidere */}
        <button className="close-popup-btn" onClick={onClose}>
          <FontAwesomeIcon icon={faXmark} size="lg" />
        </button>

        <h2 className="comment-header">Comentarii</h2>

        {/* Input + Post */}
        <div className="comment-input-row">
          <input
            type="text"
            placeholder="Scrie un comentariu..."
            className="comment-input"
            value={newComment}
            onChange={(e) => setNewComment(e.target.value)}
          />
          <button className="comment-post-btn" onClick={handlePost}>
            Post
          </button>
        </div>

        {/* Listă comentarii */}
        <div className="comment-list">
          {comments.length === 0 && (
            <p className="no-comments">Fii primul care comentează! ✍️</p>
          )}

          {comments.map((c) => (
            <div key={c.id} className="comment-item">
              <b>{c.username || "Utilizator"}:</b> {c.comment_text}
              <div className="comment-date">
                {c.created_at ? new Date(c.created_at).toLocaleString() : ""}
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default CommentPopup;
